import { InstallAgentAdditionalTargetsFormController } from '../controller/InstallAgentAdditionalTargetsFormController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { Observable } from 'rxjs';
import { AdditionalTargetsDataResponse } from '../types';

export class InstallAgentAdditionalTargetsFormWebComponent extends BaseWebComponentElement {
  private _hasNoCompanySelected: boolean;
  public controller!: InstallAgentAdditionalTargetsFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: InstallAgentAdditionalTargetsFormController,
    });
  }

  public get value(): AdditionalTargetsDataResponse {
    return this.controller.view.formGroup.value as unknown as AdditionalTargetsDataResponse;
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup?.valid$;
  }

  public get hasNoCompanySelected(): boolean {
    return this._hasNoCompanySelected;
  }

  public set hasNoCompanySelected(hasNoCompanySelected: boolean) {
    this._hasNoCompanySelected = hasNoCompanySelected;
  }
}
